var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"medication-aside"},[_c('div',{staticClass:"aside-sticky"},_vm._l((_vm.items),function(item,ind){return _c('AsideBlock',{key:ind,attrs:{"item":item},on:{"itemClick":_vm.itemClick}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }